export const PASSWORD_POLICY_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

export const PASSWORD_POLICY_MESSAGE = 'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.';

export const PASSWORD_POLICY_HINT = 'Min 8 characters, number, upper & lower case letters, and at least 1 special character.';

export const isStrongPassword = (password) => PASSWORD_POLICY_REGEX.test(password || '');
